import React, { useState, useEffect, useContext } from "react";
import { Link, Redirect } from "react-router-dom";
import Header from "../../../User/Header";
import { Form, Table, Modal, notification, Switch, Icon, Menu } from "antd";
import DrawerNoticia from "./Drawer/DrawerNoticia";
import axios from "axios";
import moment from "moment";
import { ArrowCircleLeft } from "iconsax-react";
import { GlobalContext } from "../../../app/providers/GlobalState";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Noticias = () => {
    const [ativo, setAtivo] = useState(true);
    const [noticias, setNoticias] = useState([]);
    const [noticiaId, setNoticiaId] = useState(0);
    const [visible, setVisible] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [loading, setLoading] = useState(false);

    const globalContext = useContext(GlobalContext);

    const listar = () => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/empresa/listar-informacoes",
            params: {
                ativo
            }
        })
            .then(response => {
                let noticias = [];

                response.data.map(noticia => {
                    noticias.push({
                        id: noticia.id,
                        estabelecimentos: noticia.estabelecimento,
                        titulo: noticia.titulo,
                        data: (noticia.data ? moment(noticia.data).format("DD/MM/YYYY") : "") + (noticia.hora ? " " + noticia.hora : ""),

                        opcoes: montarMenu(noticia.id, noticia.ativo)
                    });
                });

                setNoticias(noticias);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    };

    const montarMenu = (noticiaId, ativo) => {
        const divStyle = { display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-end" };

        if (ativo)
            return (
                <div style={divStyle}>
                    <Link
                        to="#"
                        className="botao-icon-inativar"
                        title="Inativar"
                        onClick={event => {
                            event.stopPropagation();
                            ativar(noticiaId, ativo);
                        }}
                    >
                        <Icon type="close" />
                    </Link>
                </div>
            );

        return (
            <div style={divStyle}>
                <Link
                    to="#"
                    className="botao-icon-ativar"
                    title="Ativar"
                    onClick={event => {
                        event.stopPropagation();
                        ativar(noticiaId, ativo);
                    }}
                >
                    <Icon type="check" />
                </Link>
                <Link
                    to="#"
                    className="botao-icon-excluir"
                    title="Excluir"
                    onClick={event => {
                        event.stopPropagation();
                        excluir(noticiaId);
                    }}
                >
                    <Icon type="delete" />
                </Link>
            </div>
        );
    };

    const excluir = noticiaId => {
        confirm({
            title: "Pretende excluir esta notícia?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/empresa/excluir-informacao",
                    params: {
                        noticiaId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Notícia excluida!");
                        listar();
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir a notícia!");
                    });
            }
        });
    };

    const ativar = (noticiaId, ativo) => {
        confirm({
            title: ativo ? "Pretende inativar esta notícia?" : "Pretende ativar esta notícia?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/empresa/ativar-informacao",
                    params: {
                        noticiaId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", ativo ? "Notícia inativada!" : "Notícia ativada!");
                        listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível inativar a notícia!" : "Não foi possível ativar a notícia!"
                        );
                    });
            }
        });
    };

    const onRowClick = noticiaId => {
        setVisible(true);
        setNoticiaId(noticiaId);
    };

    useEffect(() => {
        listar(true);
    }, [ativo]);

    const columns = [
        {
            title: "Título",
            dataIndex: "titulo"
        },
        {
            title: "Data/Hora",
            dataIndex: "data"
        },
        {
            title: "Estabelecimentos",
            dataIndex: "estabelecimentos"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    const columnsMobile = [
        {
            title: "Título",
            dataIndex: "titulo"
        },
        {
            title: "Estabelecimentos",
            dataIndex: "estabelecimentos"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo="Notícias" />
            <div className="administracao-empresa">
                <div className="container container-body">
                    <div style={{ minHeight: 600, background: "white" }}>
                        <div className="bloco-minha-conta">
                            <div className="bloco-gestor-paginas">
                                <div className="noticias container-body">
                                    <div className="controlos" style={{ display: "flex", justifyContent: "space-between" }}>
                                        <button
                                            className="botao-principal botao-principal-redondo"
                                            title="Adicionar"
                                            style={{ marginTop: 0 }}
                                            onClick={() => {
                                                setVisible(true);
                                                setNoticiaId(0);
                                            }}
                                            disabled={!ativo}
                                        >
                                            +
                                        </button>
                                        <div className="filtro">
                                            <Switch
                                                checkedChildren="Ativos"
                                                unCheckedChildren="Inativos"
                                                defaultChecked
                                                onChange={ativo => setAtivo(ativo)}
                                            />

                                            <Link
                                                className="botao-voltar2"
                                                to="/utilizador"
                                                onClick={() => {
                                                    globalContext.atualizarState({
                                                        mostrarOptPaginasPublicas: true
                                                    });
                                                }}
                                            >
                                                <ArrowCircleLeft size={34} />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="bloco-tabela">
                                        <Table
                                            id="tabela_categorias"
                                            className="tabela-paginas-desktop"
                                            loading={{
                                                spinning: loading,
                                                indicator: (
                                                    <div className="loading-data-table">
                                                        <div className="loading" />
                                                    </div>
                                                )
                                            }}
                                            columns={columns}
                                            dataSource={noticias}
                                            pagination={false}
                                            rowClassName="clickeble-row"
                                            onRow={(record, index) => {
                                                return {
                                                    onClick: () => onRowClick(record.id)
                                                };
                                            }}
                                            locale={{ emptyText: "Não existem dados!" }}
                                        />
                                        <Table
                                            id="tabela_categorias"
                                            className="tabela-paginas-mobile"
                                            loading={{
                                                spinning: loading,
                                                indicator: (
                                                    <div className="loading-data-table">
                                                        <div className="loading" />
                                                    </div>
                                                )
                                            }}
                                            columns={columnsMobile}
                                            dataSource={noticias}
                                            pagination={false}
                                            rowClassName="clickeble-row"
                                            onRow={(record, index) => {
                                                return {
                                                    onClick: () => onRowClick(record.id)
                                                };
                                            }}
                                            locale={{ emptyText: "Não existem dados!" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DrawerNoticia
                ativo={ativo}
                noticiaId={noticiaId}
                visible={visible}
                onClose={() => setVisible(false)}
                atualizar={() => {
                    setVisible(false);
                    listar();
                }}
            />
        </>
    );
};

const FormNoticias = Form.create({ name: "form-noticias" })(Noticias);

export default FormNoticias;
